import { react2angular } from 'react2angular';
import { FilterPresets } from './FilterPresets';

// Webtip module is needed for React to render
angular.module('webtip.module')
  .component('filterPresets', react2angular(
    FilterPresets, 
    [
      'filterPresets',
      'selectedPreset',
      'presetsLoading',
      'presetsError',
      'onLoadPresets',
      'onApplyPreset',
      'onSavePreset',
      'onDeletePreset',
      'currentFilterQuery',
      'currentCars',
      'currentSubsystems',
      'currentEvents',
      'currentSubsystems',
      'currentConsist',
      'isQueryValid'
    ], 
    []
  ));
